// extracted by mini-css-extract-plugin
export default {"gridDiv":"sneaker_gridDiv__Da0gy","flexDiv":"sneaker_flexDiv__rgtNG","desc":"sneaker_desc__5EHKF"};